export default __webpack_public_path__ + "a264bee45656afd781b1cc28b1525c4f.png";